import React from 'react'
import RPAInfo from '../components/RPAinfo'
import '../css/styles.css'
import '../css/general.css'
import '../css/queries.css'
import { FaPlaneDeparture, FaMoneyBillWave , FaChartBar  } from 'react-icons/fa';
import { MdCancel } from 'react-icons/md';
import { GiSuitcase } from 'react-icons/gi';
import { BsGlobe } from "react-icons/bs";
function About() {
    
   
  
    return (
      <div className="section-report-incident">
        <div className="container incident-flex">
          {/* RPA info */}
          <RPAInfo />
          <div className="rpa-info-container">
          <div className="rpa-header">
            <h1 className="rpa-title">About Us</h1>
          </div>
          
          <div className="rpa-content">
            <div className="rpa-intro">
              <p className="rpa-welcome">
                Welcome to <strong>DataScalp</strong> — your trusted source for airline performance and sustainability insights.
              </p>
              <p className="rpa-description">
                We transform complex flight data into simple, actionable intelligence for smarter travel and industry transparency.
              </p>
            </div>

            <div className="rpa-mission">
              <p className="rpa-mission-text">
                At DataScalp, our mission is to empower travelers, analysts, and aviation stakeholders with reliable, 
                up-to-date metrics on airline punctuality, cancellations, baggage handling, refund efficiency, 
                and now — environmental responsibility.
              </p>
            </div>

            <div className="rpa-features">
              <h2 className="rpa-features-title">Our platform offers:</h2>
              
              <div className="rpa-features-grid">
                <div className="rpa-feature-item">
                  <div className="rpa-feature-icon"><FaPlaneDeparture size={30} color="#1E90FF" title="On-Time Performance" />
                  </div>
                  <div className="rpa-feature-content">
                    <h3>On-Time Performance</h3>
                    <p>Track which airlines stay on schedule.</p>
                  </div>
                </div>

                <div className="rpa-feature-item">
                  <div className="rpa-feature-icon"><GiSuitcase size={30} color="#8B4513" title="Baggage Accuracy" /></div>
                  <div className="rpa-feature-content">
                    <h3>Baggage Accuracy</h3>
                    <p>Discover carriers with the fewest luggage issues.</p>
                  </div>
                </div>

                <div className="rpa-feature-item">
                  <div className="rpa-feature-icon"><MdCancel size={30} color="red" title="Cancellations" /></div>
                  <div className="rpa-feature-content">
                    <h3>Cancellations</h3>
                    <p>See who cancels the most (and the least).</p>
                  </div>
                </div>

                <div className="rpa-feature-item">
                  <div className="rpa-feature-icon"><FaMoneyBillWave size={30} color="#28a745" title="Refund Timelines" /></div>
                  <div className="rpa-feature-content">
                    <h3>Refund Timelines</h3>
                    <p>Compare how fast refunds are processed.</p>
                  </div>
                </div>

                <div className="rpa-feature-item">
                  <div className="rpa-feature-icon"><FaChartBar size={30} color="#6f42c1" title="Rankings & Insights" /></div>
                  <div className="rpa-feature-content">
                    <h3>Rankings & Insights</h3>
                    <p>Explore airline, airport, and budget airline performance through clear data views.</p>
                  </div>
                </div>

                <div className="rpa-feature-item">
                  <div className="rpa-feature-icon"><BsGlobe  size={30} color="#2ecc71" title="Eco-Friendly Ratings" /></div>
                  <div className="rpa-feature-content">
                    <h3>Eco-Friendly Ratings</h3>
                    <p>Evaluate airlines based on emissions data, fuel efficiency, and sustainability practices.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rpa-philosophy">
              <p className="rpa-philosophy-text">
                We believe that data should serve both passengers and the planet. By incorporating eco-conscious metrics, 
                DataScalp helps users make informed choices that align with their values.
              </p>
            </div>

            <div className="rpa-tagline">
              <p className="rpa-tagline-text">
                <strong>DataScalp</strong> — Let numbers guide your next flight, sustainably.
              </p>
            </div>
          </div>
        </div>
        </div>
      </div>
    )
}

export default About